import styles from "./TermOrdersBannerTemplate.module.scss";
import MiscellaneousWarning from "../../../../../common/icons/MiscellaneousWarning.tsx";
import MiscellaneousExclamationCircle from "../../../../../common/icons/MiscellaneousExclamationCircle.tsx";
import MiscellaneousXMedium from "../../../../../common/icons/MiscellaneousXMedium.tsx";
import { clsx } from "clsx";
import BaseLinkOrButton from "../../../../../common/core-ui/BaseLinkOrButton.tsx";
import { ReactNode } from "react";
import BannerContainer from "common/core-ui/BannerContainer.tsx";
import { useIntl } from "react-intl";

export default function TermOrdersBannerTemplate({
  type = "Warning",
  title,
  content,
  CTAText,
  onCTAClick,
  onClose,
}: {
  type: "Warning" | "Alert";
  title: ReactNode;
  content: ReactNode;
  CTAText: ReactNode;
  onCTAClick: () => void;
  onClose?: () => void;
}) {
  const intl = useIntl();
  return (
    <div role="alert" aria-live="polite">
      <div className={styles.bannerOuter} data-testid="term-orders-banner">
        <BannerContainer
          className={clsx(
            styles.banner,
            type === "Warning" ? styles.yellow : styles.red
          )}
          icon={
            type === "Warning" ? (
              <MiscellaneousWarning />
            ) : (
              <MiscellaneousExclamationCircle />
            )
          }
        >
          <div className={styles.bannerTitle}>{title}</div>
          <div className={styles.bannerContent}>{content}</div>
          <div className={styles.bannerCTA}>
            <BaseLinkOrButton onClick={onCTAClick} className="vst-link">
              {CTAText}
            </BaseLinkOrButton>
          </div>
          {!!onClose && (
            <BaseLinkOrButton
              className={clsx(
                "vst-icon-button-circle",
                "vst-icon-button-variant-black",
                styles.closeButton
              )}
              aria-label={intl.formatMessage({ defaultMessage: "Close" })}
              data-tooltip-content={intl.formatMessage({
                defaultMessage: "Close",
              })}
              onClick={onClose}
            >
              <MiscellaneousXMedium height={14} width={14} />
            </BaseLinkOrButton>
          )}
        </BannerContainer>
      </div>
    </div>
  );
}
